import { calculateAutoColumns } from '@elfsight/widget-utils';

function calcColumnWidth(
  containerWidth: number,
  count: number,
  gap: [number, number]
) {
  const gapsSum = gap[0] * (count - 1);
  return (containerWidth - gapsSum) / count;
}

function calcIndent(
  containerWidth: number,
  width: number,
  count: number,
  gap: [number, number]
) {
  const occupiedWidth = width * count + gap[0] * (count - 1);
  return (containerWidth - occupiedWidth) / 2;
}

type ComputeColumnsProps = {
  columns: 'auto' | number;
  basis: number;
  gap: [number, number];
  containerWidth: number;
  stretch: boolean;
};

export function computeColumns({
  columns,
  basis,
  gap,
  stretch = true,
  containerWidth
}: ComputeColumnsProps): [number, number, number] {
  const isAuto = typeof columns !== 'number' && columns === 'auto';

  if (containerWidth === 0 || (isAuto && basis === 0) || columns === 0) {
    return [0, 0, 0];
  }

  if (isAuto) {
    const estimatedCount = calculateAutoColumns({
      containerWidth,
      columnsBasis: basis,
      itemSpacing: gap[0]
    });
    let estimatedWidth = 0;

    do {
      estimatedWidth = calcColumnWidth(containerWidth, estimatedCount, gap);
    } while (estimatedWidth < basis && estimatedCount > 1);

    if (!stretch && (estimatedCount > 1 || containerWidth > basis)) {
      estimatedWidth = basis;
    }

    const indent = !stretch
      ? calcIndent(containerWidth, estimatedWidth, estimatedCount, gap)
      : 0;

    return [estimatedCount, estimatedWidth, indent];
  }

  if (typeof columns !== 'number') {
    return [0, 0, 0];
  }

  return [columns, calcColumnWidth(containerWidth, columns, gap), 0];
}
